import React, { Component } from "react";
import { connect } from "react-redux";
import { shape, node, func, bool, string } from "prop-types";

import * as i18nUtils from "util/i18n";
import { selectors } from "reducers/widgets";

import { resizableRoute } from "pages/_components/Resizable";
import PendingTransactionList from "pages/transactions/PendingTransactionList";
import WidgetList from "pages/desktop/widgets/WidgetList";
import WidgetLoading from "pages/_components/WidgetLoading";
import NoProduct from "pages/desktop/widgets/_components/NoProduct";
import WidgetHeader from "./_components/WidgetHeader";
import PendingTransactionsListItem from "./_components/PendingTransactionsListItem";

const WIDGET_NAME = "pendingTransactions";

class PendingTransactions extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        isFetching: bool,
        isEditable: bool,
        closeButton: node,
        draggableItemProps: shape({}).isRequired,
        goTo: string,
    };

    static defaultProps = {
        closeButton: null,
        isFetching: false,
        isEditable: false,
        goTo: "",
    };

    renderList = (list) => {
        const { isDesktop, isFetching, isEditable } = this.props;

        if (list) {
            if (isDesktop) {
                return <PendingTransactionList showHeader={false} />;
            }
            return list;
        }
        if (!isFetching) {
            return (
                <article className="table" aria-hidden={isEditable}>
                    <NoProduct
                        text={`desktop.widgets.${WIDGET_NAME}.empty`}
                        imagePath="images/coloredIcons/transfer.svg"
                    />
                </article>
            );
        }
        return <WidgetLoading loading />;
    };

    render() {
        const { closeButton, draggableItemProps, goTo } = this.props;
        const uiAutomationProp = { "data-ui-automation": "widgetPendingTransactions" };
        return (
            <WidgetList
                item={PendingTransactionsListItem}
                keyExtractor={(item) => item.idTransaction}
                name={WIDGET_NAME}
                {...this.props}>
                {(list) => (
                    <section
                        className="widget"
                        {...uiAutomationProp}
                        {...draggableItemProps}
                        aria-roledescription={i18nUtils.get("desktop.widgets.message.roleDescription")}>
                        <WidgetHeader
                            title={i18nUtils.get("desktop.widgets.pendingTransactions.title")}
                            action={closeButton}
                            goTo={goTo}
                        />
                        {this.renderList(list)}
                        <div className="overlay" />
                    </section>
                )}
            </WidgetList>
        );
    }
}

const mapStateToProps = (state) => ({
    isFetching: selectors.getWidget(state, WIDGET_NAME).isFetching,
});

export default connect(mapStateToProps)(resizableRoute(PendingTransactions));
